// extracted by mini-css-extract-plugin
module.exports = {"widgetFiles":"widget-space--widgetFiles--2GVS9","widgetFilesMain":"widget-space--widgetFilesMain--1cEgZ"};